/**
 * Formatea una fecha sin problemas de zona horaria
 * Parsea la fecha manualmente para evitar que se muestre un día antes
 */
export const formatDate = (dateString?: string): string => {
	if (!dateString) return '-';
	try {
		// Si la fecha viene en formato YYYY-MM-DD, parsearla manualmente
		const dateMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
		if (dateMatch) {
			const year = parseInt(dateMatch[1], 10);
			const month = parseInt(dateMatch[2], 10) - 1; // Los meses en JS son 0-indexed
			const day = parseInt(dateMatch[3], 10);
			const date = new Date(year, month, day);
			return date.toLocaleDateString('es-ES', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric',
			});
		}
		// Si no coincide el formato, intentar con Date normal
		const date = new Date(dateString);
		if (isNaN(date.getTime())) {
			return dateString;
		}
		return date.toLocaleDateString('es-ES', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
		});
	} catch {
		return dateString;
	}
};

/**
 * Crea una fecha sin problemas de zona horaria para comparaciones
 */
export const parseDate = (dateString?: string): Date | null => {
	if (!dateString) return null;
	try {
		const dateMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
		if (dateMatch) {
			const year = parseInt(dateMatch[1], 10);
			const month = parseInt(dateMatch[2], 10) - 1;
			const day = parseInt(dateMatch[3], 10);
			return new Date(year, month, day);
		}
		const date = new Date(dateString);
		return isNaN(date.getTime()) ? null : date;
	} catch {
		return null;
	}
};
